import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isSubstringPartOfString',
    standalone: false
})
export class IsSubstringPartOfStringPipe implements PipeTransform {

  transform(text: string, textPart: string): boolean {
    if (!textPart) {
      return false;
    }

    return text?.match(RegExp(textPart, 'ig'))?.length > 0;
  }
}
